import request from '@/utils/http'

// 签收登记
export const signRegister = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/signRegister',
        method: 'post',
        data: data,
    })
}
// 单据上传
export const paperUpload = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/paperUpload',
        method: 'post',
        data: data,
    })
}
// 订单创建/修改接口
export const waybillCreateOrUpdate = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/createOrUpdate',
        method: 'post',
        data: data,
    })
}

// 审核通过
export const waybillOrderSiteAduit = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/siteAduit',
        method: 'post',
        data: data,
    })
}

// 审核-作废
export const waybillOrderSiteCancel = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/siteCancel',
        method: 'post',
        data: data,
    })
}

// 运单下发
export const waybillOrderSiteIssue = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/siteIssue',
        method: 'post',
        data: data,
    })
}

// 分页查询
export const waybillOrderQueryPage = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/queryPage',
        method: 'post',
        data: data,
    })
}

// 运单信息查询通过运单号
export const getWaybillOrderByWaybillNo = params => {
    return request({
        url: '/api-ntp/ntp/waybill-order/getWaybillOrderByWaybillNo',
        method: 'get',
        params,
    })
}

// 删除已上传图片
export const deleteFileById = params => {
    return request({
        url: '/api-ntp/ntp/waybill-file/self/deleteFileById',
        method: 'get',
        params,
    })
}

// 获取运单运费支付状态
/**
 *
 * @param {string} data.waybillNo 运单号waybillNo（string）
 * @param {int} data.feeType 费用类型feeType（int）
 * @returns {
 *   data: [{
 *     feeType: number,
 *     paymentStatus: number
 * }]
 * }
 */
export const getWaybillPayStatus = data => {
    return request({
        url: '/api-ntp-pay/ntp/pay/payment/qryPayStatus',
        method: 'post',
        data: data,
    })
}

//  修改运费
export const modifyUpdateTransportAmount = (data, silent = false) => {
    return request({
        url: '/api-ntp/ntp/waybill-order/updateTransportAmount',
        method: 'post',
        data,
        options: {
            silent,
        },
    })
}

//  修改排车
export const modifyDispatchInfo = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/updateDispatchInfoByWaybillNo',
        method: 'post',
        data,
    })
}

//  获取留存运费率
export const getBaseAnhzInfoSelectList = data => {
    return request({
        url: '/api-ntp/ntp/baseAnhzInfo/selectList',
        method: 'post',
        data,
    })
}

//  运单文件创建/修改接口
export const createOrUpdate = data => {
    return request({
        url: '/api-ntp/ntp/waybill-file/self/createOrUpdate',
        method: 'post',
        data,
    })
}

//  运单申请支付运费
export const applyPay = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/dispatchApply',
        method: 'post',
        data,
    })
}

//  运单文件分页查询接口;
export const getWaybillFileQueryPage = data => {
    return request({
        url: '/api-ntp/ntp/waybill-file/queryPage',
        method: 'post',
        data,
    })
}

// 统计面板查询;
export const getWaybillQueryStatList = params => {
    return request({
        url: '/api-ntp/ntp/waybill-order/queryStatList',
        method: 'get',
        params,
    })
}

//  抵达;
export const getZtbArrival = data => {
    return request({
        url: '/api-ntp/ntp/ztb/ztbArrival',
        method: 'post',
        data,
    })
}

// 发车;
export const getZtbDepart = data => {
    return request({
        url: '/api-ntp/ntp/ztb/ztbDepart',
        method: 'post',
        data,
    })
}

// 运单签收
export const waybillSignNew = params => {
    return request({
        url: '/api-ntp/ntp/waybill-order/waybillSignNew',
        method: 'get',
        params,
    })
}

// 创建订单
export const getWaybilldaNiuWholeOrderCreate = params => {
    return request({
        url: '/api-ntp/ntp/waybill-order/daNiuWholeOrderCreate',
        method: 'get',
        params,
    })
}

// 地址变更
export const getTmsOrderAddressCreateOrUpdate = data => {
    return request({
        url: '/api-ntp/ntp/tms-order-address/createOrUpdate',
        method: 'post',
        data,
    })
}

/**
 * 运单中止
 * @param {*} params: { waybillNo }
 * @returns
 */
export const waybillStop = params => {
    return request({
        url: '/api-ntp/ntp/waybill-order/waybillStop',
        method: 'get',
        params,
    })
}

// 获取车牌号
export const supplierCarQueryInAdvance = data => {
    return request({
        url: '/api-ntp/ntp/supplierCar/queryInAdvance',
        method: 'post',
        data,
    })
}

// 达牛信息批量上传API
// 数据上传
export const getWaybillUploadData = params => {
    return request({
        url: '/api-ntp/ntp/daniu/dataUpload',
        method: 'get',
        params,
    })
}
// 达牛数据批量上传
export const daniuBatchUplaod = data => {
    return request({
        url: '/api-ntp/ntp/daniu/daniuBatchUpload',
        method: 'post',
        data,
    })
}

/**
 *
 * @param {string} waybillNo 运单号
 * @returns Y/N （支付完成/未完成）
 */
export const qryPayBillStatus = data => {
    return request({
        url: '/api-ntp-pay/ntp/pay/payment/qryPayBillStatus',
        method: 'post',
        data,
    })
}

// 修改运单其它信息(客户订单号、备注等)
export const updateWaybillOrderCustomer = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/updateWaybillOrderCustomer',
        method: 'post',
        data,
    })
}

// 异常预警列表查询
export const queryWarningInfo = data => {
    return request({
        url: '/api-ntp/ntp/tms-waybill-warning/queryPage',
        method: 'post',
        data,
    })
}

// 工作台-运单统计
export const queryWaybillCountStat = customerCode => {
    return request({
        url: `/api-ntp/ntp/wechat/queryWeChatStatusCatch?customerCode=${customerCode}`,
        method: 'get',
    })
}

// 工作台-异常预警统计
export const queryWaybillWarningStat = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/queryWarningUnion',
        method: 'post',
        data,
    })
}
// 判断是否有装卸货照片
export const isExistLoadAndUnloadImageByWaybillNo = data => {
    return request({
        url: `/api-ntp/ntp/waybill-file/isExistLoadAndUnloadImageByWaybillNo?waybillNo=${data}`,
        method: 'get',
    })
}
// 提交审核
export const excSubmitAudit = (data, silent = false) => {
    return request({
        url: '/api-ntp/ntp/waybill-order/excSubmitAudit',
        method: 'post',
        data,
        options: {
            silent,
        },
    })
}

/**
 * 根据运单编码、货主编码、司机编码查询评价
 * @param data.customerCode string 货主编号
 * @param data.driverNo string 司机编号
 * @param data.waybillNo string 运单编号
 */
export const getEvaluation = data => {
    return request({
        url: '/api-ntp/ntp/tms-evaluation/getEvaluation',
        method: 'post',
        data,
    })
}

/**
 *
 * @param data.createTime string($date-time) 创建时间
 * @param data.createUserCode string 创建用户
 * @param data.customerCode string example: string 货主编号 v
 * @param data.customerName string example: string 货主名称 v
 * @param data.customerSatisfactionLevel integer($int32) example: 5 minimum: -128 maximum: 127 客户满意度等级:1-5等级
 * @param data.deleteFlag integer($int32) example: 0 是否逻辑删除(0-否,1-是)
 * @param data.driverCreditLevel integer($int32) example: 5 minimum: -128 maximum: 127 司机信誉等级:1-5等级
 * @param data.driverMobile string example: 0 司机手机号 v
 * @param data.driverName string example: 0 司机姓名 v
 * @param data.driverNo string example: string 司机编号 v
 * @param data.evaluationType integer($int33) example: 0 minimum: -128 maximum: 127 评价类型,0.货主评价 v === 0
 * @param data.goodsIntegrityLevel integer($int32) example: 5 minimum: -128 maximum: 127 货物完整等级:1-5等级
 * @param data.id integer($int64) 主键id
 * @param data.offset integer($int32) example: 0 偏移量(默认:0)
 * @param data.orderBy string 排序字段
 * @param data.orderByType string 排序方式:asc/desc
 * @param data.pageNo integer($int32) example: 1 第几页(从1开始)
 * @param data.pageSize integer($int32) example: 30 每页数量(默认:30)
 * @param data.remark string example: 备注 备注
 * @param data.serviceQualityLevel integer($int32) example: 5 minimum: -128 maximum: 127 服务质量等级:1-5等级
 * @param data.tenantCode string 租户字段
 * @param data.transportEfficiencyLevel integer($int32) example: 5 minimum: -128 maximum: 127 运输效率等级:1-5等级
 * @param data.transportSafeLevel integer($int32) example: 5 minimum: -128 maximum: 127 运输安全等级:1-5等级
 * @param data.updateTime string($date-time) 修改时间
 * @param data.updateUserCode string 修改用户
 * @param data.version integer($int64) 数据版本号
 * @param data.waybillNo string example: string 运单编号 v
 */
export const saveEvaluation = data => {
    return request({
        url: '/api-ntp/ntp/tms-evaluation/save',
        method: 'post',
        data,
    })
}

// 运单修改日志（记录）
export const queryWaybillOperateLog = data => {
    return request({
        url: '/api-ntp/ntp/tms-waybill-order-operate-log/queryPage',
        method: 'post',
        data,
    })
}

// 预审校验结果查询
export const queryWaybillPreCheck = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/preValid/query',
        method: 'post',
        data,
    })
}

// 预审校验
export const waybillPreCheckValid = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/preValid',
        method: 'post',
        data,
    })
}

// 异常预警统计
export const queryWaybillWarningUnion = data => {
    return request({
        url: '/api-ntp/ntp/tms-waybill-warning/queryWarningUnion',
        method: 'post',
        data,
    })
}

// TK单信息
export const getWaybillTKInfo = data => {
    return request({
        url: '/api-ntp/ntp/tms-waybill-tk-info/queryPage',
        method: 'post',
        data,
    })
}

// TK单-货物详细信息
export const getWaybillTKGoodsDetail = data => {
    return request({
        url: '/api-ntp/ntp/tms-waybill-tk-goods-detail/queryPage',
        method: 'post',
        data,
    })
}

// 装卸地列表
export const getWaybillWaypoint = params => {
    return request({
        url: 'api-ntp/ntp/tms-waybill-tk-info/waybillNoWaypoint',
        method: 'get',
        params,
    })
}

// 异常运单-司机、车辆、运单认证提交
export const certSubmit = data => {
    return request({
        url: '/api-ntp/ntp/jumeng/submitRedo',
        method: 'post',
        data,
    })
}

// 运单-风控申诉查询
export const queryWaybillAppeal = params => {
    return request({
        url: '/api-ntp/ntp/jumeng/appealQuery',
        method: 'get',
        params,
    })
}

// 运单-风控申诉
export const waybillAppeal = data => {
    return request({
        url: '/api-ntp/ntp/jumeng/appeal',
        method: 'post',
        data,
    })
}

// 运单-风控申诉-图片上传
export const ossUpload = (data, params) => {
    const formData = new FormData()
    formData.append('file', data)
    formData.append('bucket', params.bucket)
    formData.append('businessKey', params.businessKey)
    formData.append('publicRead', params.publicRead)
    params.contentType && formData.append('contentType', params.contentType)
    return request({
        url: '/api-ntp/ntp/lcFile/upload',
        method: 'post',
        data: formData,
    })
}

// 工作台-合同消息提醒
export const queryMsgTitle = params => {
    return request({
        // url: '/api-ntp/ntp/baseAnhzInfo/queryMsgTitle',
        url: `/api-ntp/ntp/baseAnhzInfo/queryMsgTitle/${params}`,
        method: 'get',
        // params
    })
}

/**
 * 绑定设备号
 * waybillNo: 运单编号
 * deviceType: 设备号类型(10 G7 20小黑卡)
 * deviceNo: 设备号
 */
export const boundDeviceNo = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/boundDeviceNo',
        method: 'post',
        data,
    })
}
// 解绑设备号
export const unboundDeviceNo = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/unboundDeviceNo',
        method: 'post',
        data,
    })
}
// 编辑运单更新设备号
export const updateDeviceNo = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/updateDeviceNo',
        method: 'post',
        data,
    })
}

// 运单列表-重推，第三方平台运单功能重推
export const waybillOrderChannelWaybillRePush = data => {
    return request({
        url: '/api-ntp/ntp/G7/channelWaybillRePush',
        method: 'post',
        data: data,
    })
}

// 批量签收
export const batchSign = data => {
    return request({
        url: '/api-ntp/ntp/waybill-order/batchSign',
        method: 'post',
        data,
    })
}
